export const INTEGRATION_MAPPER = [
  {
    key: "ga",
    value: "Google Analytics",
  },
  {
    key: "gsc",
    value: "Google Search Console",
  },
  {
    key: "wp",
    value: "Wordpress",
  },
  {
    key: "wc",
    value: "WooCommerce",
  },
  {
    key: "mc",
    value: "Mailchimmp",
  },
  {
    key: "aks",
    value: "Akismet (Anti-Spam)",
  },
];
